// Analytics
export const ADD_TO_CART = 'Add to cart';
export const CHECK_NEARBY_STORE = 'check nearby store';
export const COMPARE = 'compare';
export const PRODUCT = 'product';
export const PRODUCT_DETAILS = 'product details';
export const PRODUCT_IMAGE = 'product image';
export const RATING = 'rating';
export const SAVE_TO_FAVORITE = 'save to favorite';
export const PRODUCT_POD_CLICK = 'product-pod.click';
export const PRODUCT_POD_ATC = 'product-pod.add-to-cart';
export const PRODUCT_POD_SIMILAR = 'product-pod.see-similar-items';
export const PRODUCT_POD_IRG_ATC = 'product-pod-irg.add-to-cart';
export const BADGE_CLICKTHROUGH = 'badge.clickthrough';
export const PRODUCT_POD_COMPARE = 'product-pod.compare';
export const SERVICES_BUTTON_CLICK = 'services-button.click';

// Fullfillment
export const FULFILLMENT_LOCATION_STH = 'DirectShip';
export const FULFILLMENT_METHOD_STH = 'ShipToHome';
export const FULFILLMENT_METHOD_BOSS = 'ShipToStore';
export const FULFILLMENT_METHOD_BOPIS = 'BOPIS';
export const FULFILLMENT_METHOD_BODFS = 'DeliverFromStore';
export const FULFILLMENT_METHOD_APPLIANCE = 'DirectDelivery';
export const NON_RETURNABLE_MESSAGE = 'Made to order, not returnable';
export const INVALID_SSKU = '11111111';
export const CONFIGURABLE_BLINDS = 'CONFIGURABLE_BLINDS';
export const MERCHANDISE = 'MERCHANDISE';
export const MAJOR_APPLIANCE = 'MAJOR_APPLIANCE';

// CTA Buttons
export const SCHEDULE_A_MEASURE = 'Schedule a Measure';
export const DESIGN_AND_ORDER = 'Design and Order';
export const REQUEST_A_QUOTE = 'Request a Quote';
export const SCHEDULE_A_CONSULTATION = 'Schedule a Consultation';
export const BUILD_AND_BUY = 'Build and Buy';
export const VIEW_DETAILS = 'View Details';
export const CHOOSE_YOUR_OPTIONS = 'Choose Your Options';

// PRODUCT SERVICE ADD ONS
export const DUAL_PATH_IDENTIFIER = 'SFI_Available';

// PRODUCT DETAILS
export const PRODUCT_RECORD_TYPE = 10000003;
export const MAX_KEYWORD_LENGTH = 27;
export const HOME_DEPOT_QUOTE_CENTER = 'HDQC';
